import { MaturityScheduleResponse } from '../../model/MaturitySchedule.model';
import { TransactionResponse } from '../../model/Transaction.model';
import CustomerResponse from '../../model/Customer.model';

// Common Excel styling interface
export interface ExcelCellStyle {
  font?: {
    bold?: boolean;
    size?: number;
    color?: { argb: string };
  };
  fill?: {
    type: 'pattern';
    pattern: 'solid';
    fgColor: { argb: string };
  };
  alignment?: {
    horizontal?: 'left' | 'center' | 'right';
    vertical?: 'top' | 'middle' | 'bottom';
  };
  border?: {
    top?: { style: 'thin' | 'medium' | 'thick' };
    left?: { style: 'thin' | 'medium' | 'thick' };
    bottom?: { style: 'thin' | 'medium' | 'thick' };
    right?: { style: 'thin' | 'medium' | 'thick' };
  };
}

// Extended interface for enriched maturity schedule with customer details
export interface EnrichedMaturityScheduleForExport
  extends MaturityScheduleResponse {
  customerDetails?: CustomerResponse;
}

// Multi export data interface
export interface MultiExportData {
  records: EnrichedMaturityScheduleForExport[];
  month: number;
  year: number;
}

// Multi withdrawal export data interface
export interface MultiWithdrawalExportData {
  records: any[];
  month: number;
  year: number;
}

// Common Excel colors
export const ExcelColors = {
  PRIMARY_HEADER: 'FF666666',
  SECONDARY_HEADER: 'FF808080',
  TABLE_HEADER: 'FF999999',
  WHITE_TEXT: 'FFFFFFFF',
  BLACK_TEXT: 'FF000000',
} as const;
